// Bilingual content for Fit & Wellness landing page
export const translations = {
    it: {
        nav: {
            method: "Il Metodo",
            protocols: "Protocolli",
            bio: "Bio",
            testimonials: "Recensioni",
            resources: "Risorse",
            insights: "Insights",
            fuelingHub: "Fueling Hub",
            contact: "Contatti",
            cta: "Prenota",
        },
        common: {
            showAllProtocols: "Vedi tutti i 7 protocolli",
            showLess: "Mostra meno",
            showAllArticles: "Tutti gli articoli",
        },
        hero: {
            overline: "Personal Trainer · Performance Method",
            headlineLine1: "Allenare.",
            headlineLine2: "Riallineare.",
            headlineLine3: "Rigenerare.",
            sub: "Luca La Capria — Personal Trainer, Preparatore Atletico e Consulente Alimentare.",
            description: "Un metodo costruito su misura per chi vive ad alta intensità. Forza, postura, performance e lucidità mentale: nessuna formula generica, solo allenamento di precisione.",
            ctaConsult: "Prenota Consulenza Strategica",
            ctaPrimary: "Scrivi su WhatsApp",
            ctaSecondary: "Contatta via Email",
            scroll: "Scorri",
            tickerWords: ["Forza", "Postura", "Performance", "Recovery", "Mindset", "Longevità"],
        },
        method: {
            overline: "Il Metodo",
            headline: "Il Metodo Fit & Wellness",
            description: "Sette protocolli, una sola filosofia: progettare il corpo come si progetta un sistema di performance. Ogni percorso è un'architettura di precisione costruita sulla tua biologia, sui tuoi tempi e sui tuoi obiettivi.",
            protocolLabel: "Protocollo",
            discoverMore: "Approfondisci",
        },
        protocols: [
            {
                id: "01",
                slug: "longevita-attiva-over-45",
                name: "Longevità Attiva Over 45",
                tagline: "Forza, mobilità e vitalità per la seconda metà della vita.",
                description: "Un programma costruito sulle scienze della longevità: forza funzionale, capacità cardiovascolare e mobilità articolare per restare brillanti, agili e potenti dopo i 45 anni.",
                detail: {
                    intro: "Un percorso pensato per chi vuole continuare a vivere — non solo invecchiare. Lavoro insieme a te per costruire un corpo forte, mobile e funzionale, capace di affrontare ogni decade con la stessa lucidità e vitalità.",
                    forWho: "Uomini e donne dai 45 anni in su che vogliono mantenere (o ritrovare) forza, energia e mobilità. Adatto sia a chi non si allena da tempo, sia a chi vuole strutturare meglio il proprio allenamento.",
                    includes: [
                        "Valutazione funzionale iniziale (mobilità, forza, postura)",
                        "Programma di forza funzionale progressiva",
                        "Mobilità articolare e prevenzione infortuni",
                        "Lavoro cardio-metabolico modulato",
                        "Indicazioni nutrizionali generali per la longevità",
                    ],
                    format: "In presenza (Genova) o online · 1-a-1",
                    duration: "Percorso minimo 8 settimane · consigliato cicli da 12 settimane",
                },
            },
            {
                id: "02",
                slug: "reset-metabolico-neuro-wellness",
                name: "Reset Metabolico & Neuro-Wellness (ADHD)",
                tagline: "Energia mentale e metabolica ricalibrata.",
                description: "Allenamento, alimentazione e neuro-wellness integrati per ricalibrare il metabolismo e supportare la focalizzazione cognitiva — pensato anche per profili ADHD.",
                detail: {
                    intro: "Un protocollo che integra movimento, nutrizione e tecniche di regolazione del sistema nervoso. Pensato per chi cerca energia stabile, lucidità mentale e ritrovata padronanza del proprio metabolismo — incluse persone con tratti ADHD.",
                    forWho: "Professionisti, creativi e persone con profili ADHD o sindrome metabolica che vogliono ritrovare stabilità energetica, focus e composizione corporea sana.",
                    includes: [
                        "Reset abitudini alimentari (timing, qualità, integrazione)",
                        "Allenamento adattato a finestre di energia e focus",
                        "Tecniche di respirazione e gestione dello stress",
                        "Strategie di routine quotidiana sostenibile",
                        "Monitoraggio settimanale di energia e umore",
                    ],
                    format: "In presenza (Genova) o online · 1-a-1",
                    duration: "Cicli da 8 a 16 settimane",
                },
            },
            {
                id: "03",
                slug: "postura-riatletizzazione",
                name: "Postura & Riatletizzazione",
                tagline: "Riallineare il corpo, riattivare l'atleta.",
                description: "Valutazione posturale, correzione delle catene cinetiche e ritorno alla performance dopo infortuni, sedentarietà o stress accumulato.",
                detail: {
                    intro: "Quando il corpo si disallinea, ogni movimento diventa una fatica nascosta. Questo protocollo ricostruisce la base — postura, mobilità, catene cinetiche — per restituirti un corpo che lavora con te, non contro di te.",
                    forWho: "Persone con problemi posturali, dolori cronici di schiena o cervicale, chi torna ad allenarsi dopo un infortunio, sedentari che vogliono ripartire bene.",
                    includes: [
                        "Valutazione posturale e funzionale completa",
                        "Esercizi di mobilità e attivazione mirata",
                        "Correzione delle catene cinetiche",
                        "Riatletizzazione progressiva",
                        "Educazione al movimento quotidiano",
                    ],
                    format: "In presenza (Genova) · sessioni 1-a-1",
                    duration: "Percorso minimo 6 settimane · spesso 12-16 settimane",
                },
            },
            {
                id: "04",
                slug: "express-performance-20",
                name: "Express Performance 20'",
                tagline: "Massimo risultato in minimo tempo.",
                description: "Sessioni ad alta densità da 20 minuti, ingegnerizzate per chi ha un'agenda chiusa ma non vuole rinunciare a forza, lucidità e tono.",
                detail: {
                    intro: "Venti minuti, niente di più — ma costruiti come si costruisce una sessione professionale. HIIT, forza funzionale e lavoro neuro-muscolare in formato concentrato per chi ha agende fitte ma standard alti.",
                    forWho: "Professionisti, manager e high performer con tempo limitato che cercano risultati concreti senza sacrificare la qualità.",
                    includes: [
                        "Sessioni da 20 minuti ad alta densità",
                        "HIIT, forza funzionale e mobilità",
                        "Programma adattato all'agenda settimanale",
                        "Possibilità di sessioni anche in studio o ufficio",
                        "Indicazioni recovery e ricarica",
                    ],
                    format: "In presenza (Genova) o online · 1-a-1 o coppia",
                    duration: "Format continuativo · risultati visibili in 4-8 settimane",
                },
            },
            {
                id: "05",
                slug: "mind-recovery",
                name: "Mind & Recovery",
                tagline: "Recupero attivo, sonno, sistema nervoso.",
                description: "Protocolli di respirazione, mobilità dolce e gestione dello stress per ricostruire il sistema nervoso e ottimizzare il recupero profondo.",
                detail: {
                    intro: "Allenarsi tanto non basta: la performance reale nasce dal recupero. Questo protocollo lavora sul sistema nervoso parasimpatico — respirazione, mobilità dolce, regolazione del sonno — per riportare il corpo in equilibrio.",
                    forWho: "Persone sotto stress cronico, chi soffre di insonnia o difficoltà di recupero, atleti amatoriali che vogliono ottimizzare il post-allenamento.",
                    includes: [
                        "Tecniche di respirazione (box, fisiologica, Wim Hof)",
                        "Mobilità dolce e rilascio miofasciale",
                        "Routine pre-sonno strutturata",
                        "Gestione dello stress e tecniche meditative",
                        "Monitoraggio HRV e qualità del recupero",
                    ],
                    format: "In presenza (Genova) o online · 1-a-1",
                    duration: "Cicli da 4 a 12 settimane",
                },
            },
            {
                id: "06",
                slug: "equilibrio-femminile",
                name: "Equilibrio Femminile",
                tagline: "Allenamento ciclico, ormoni e forza.",
                description: "Un percorso dedicato all'universo femminile: cicli ormonali, forza, composizione corporea e benessere — costruito con scienza e sensibilità.",
                detail: {
                    intro: "Il corpo femminile non è un corpo maschile in versione ridotta. Questo protocollo allena in sintonia con i cicli ormonali, modulando intensità, volume e nutrizione per ottimizzare forza, energia e benessere fase per fase.",
                    forWho: "Donne in ogni fase della vita — pre-mestruale, fertile, perimenopausa, menopausa — che vogliono allenarsi rispettando la propria biologia.",
                    includes: [
                        "Allenamento ciclico ormone-aware",
                        "Programma forza, ipertrofia, cardio modulato",
                        "Nutrizione per fase del ciclo",
                        "Gestione di ritenzione, energia, umore",
                        "Lavoro su pavimento pelvico e core",
                    ],
                    format: "In presenza (Genova) o online · 1-a-1 o piccoli gruppi",
                    duration: "Percorso continuativo · revisioni trimestrali",
                },
            },
            {
                id: "07",
                slug: "metodo-online",
                name: "Metodo Online",
                tagline: "Il metodo, ovunque tu sia.",
                description: "Il sistema Fit & Wellness in formato digitale: programmi personalizzati, video-coaching e monitoraggio costante per chi è sempre in movimento.",
                detail: {
                    intro: "Per chi viaggia, vive all'estero o non può raggiungere lo studio — il Metodo Fit & Wellness in versione completamente online, mantenendo lo stesso livello di personalizzazione e cura del lavoro in presenza.",
                    forWho: "Professionisti in trasferta, italiani all'estero, atleti amatoriali, chi non ha accesso a un trainer locale di fiducia.",
                    includes: [
                        "Programma 100% personalizzato su app",
                        "Video-correzione di esecuzione esercizi",
                        "Call settimanali o quindicinali su Zoom/WhatsApp",
                        "Chat diretta per dubbi e adattamenti",
                        "Indicazioni nutrizionali e recovery",
                    ],
                    format: "100% online · Zoom + app + WhatsApp",
                    duration: "Cicli da 4, 8 o 12 settimane",
                },
            },
        ],
        protocolPage: {
            backToProtocols: "Torna ai protocolli",
            backHome: "Torna alla home",
            forWho: "Per chi è",
            includes: "Cosa include",
            format: "Modalità",
            duration: "Durata",
            ctaTitle: "Vuoi iniziare questo protocollo?",
            ctaText: "Scrivimi per una consulenza gratuita e costruiamo insieme il programma più adatto a te.",
            ctaWhatsapp: "Scrivi su WhatsApp",
            ctaEmail: "Contatta via Email",
            protocolNumber: "Protocollo",
            notFound: "Protocollo non trovato",
        },
        bio: {
            overline: "Chi Sono",
            headline: "Luca La Capria",
            role: "Personal Trainer · Preparatore Atletico · Consulente Alimentare",
            paragraphs: [
                "Sono Luca La Capria. Pratico sport dall'infanzia — calcio agonistico, poi corsa competitiva su 10–12 km — e da oltre un decennio progetto percorsi di allenamento per persone comuni di ogni età, atleti amatoriali e professionisti.",
                "Il Metodo Fit & Wellness nasce dall'incrocio di tre discipline: scienza dell'allenamento (forza, HIIT, corsa, posturale), nutrizione funzionale e neuro-wellness. La mia missione è supportarti a livello pratico nel ricostruire mente e corpo, per il tuo benessere e la tua longevità.",
                "Lavoro 1-a-1, in piccoli gruppi e in formato online, sia in presenza che da remoto. Seguo persone con problemi posturali, chi vuole ritrovare forma e energia e atleti che cercano un'evoluzione concreta. Nessuna formula generica: solo allenamento di precisione costruito sul lungo periodo.",
            ],
            credentials: [
                { label: "Anni di esperienza", value: "12+" },
                { label: "Clienti seguiti", value: "200+" },
                { label: "Protocolli", value: "7" },
                { label: "Sessioni / anno", value: "1.4K" },
            ],
            certifications: [
                "Personal Trainer — NonSoloFitness",
                "Preparatore Atletico e Sportivo",
                "Istruttore HIIT & Allenamento Femminile",
                "Educatore Nutrizione Sportiva e Clinica",
                "Istruttore Ginnastica Posturale",
                "Mental Trainer per il Fitness",
            ],
        },
        testimonials: {
            overline: "Recensioni",
            headline: "La voce di chi ha scelto il Metodo",
            description: "Recensioni reali da ProntoPro e clienti del Metodo Fit & Wellness.",
            verified: "Recensione verificata",
            items: [
                { quote: "Fantastico coach! Gli allenamenti rispettano le mie esigenze, sempre disponibile, incoraggiante e realistico. Consigliatissimo!", author: "Anna P.", role: "Cliente · 02/2026", source: "ProntoPro" },
                { quote: "Professionista con la P maiuscola. Super disponibile e sempre pronto a capire ogni situazione al meglio. Con un bagaglio tecnico completo. Provare per credere.", author: "Mattia B.", role: "Cliente · 11/2025", source: "ProntoPro" },
                { quote: "Programma di allenamento adatto alle esigenze anche complesse di tempo (lavoro su turni). Assistenza puntuale, sai di poterci contare e sa essere comprensivo rispetto al tempo disponibile. Consigliato.", author: "Davide B.", role: "Cliente · 08/2025", source: "ProntoPro" },
                { quote: "Il protocollo Express Performance 20' si è integrato perfettamente nelle mie giornate. Risultati misurabili, approccio impeccabile.", author: "Alessandra R.", role: "Manager", source: "Cliente diretto" },
                { quote: "Sono tornato in forma dopo un infortunio cronico grazie al lavoro su postura e riatletizzazione. Metodo serio, professionale e su misura.", author: "Marco V.", role: "Atleta amatore", source: "Cliente diretto" },
                { quote: "Approccio mente-corpo davvero unico. Respirazione, allenamento e nutrizione integrati — finalmente energia stabile per tutta la giornata.", author: "Chiara M.", role: "Professionista", source: "Cliente diretto" },
            ],
        },
        cta: {
            overline: "Inizia",
            headline: "Pronto a iniziare il tuo Metodo?",
            description: "Una consulenza riservata per disegnare il protocollo Fit & Wellness più adatto al tuo profilo, al tuo tempo e ai tuoi obiettivi.",
            calendly: "Prenota Consulenza Strategica",
            whatsapp: "Scrivi su WhatsApp",
            email: "Scrivi una Email",
            phoneLabel: "Telefono",
            emailLabel: "Email",
        },
        resources: {
            overline: "Area Risorse",
            headline: "Risorse gratuite per iniziare bene.",
            description: "Guide strategiche del Metodo Fit & Wellness, su temi precisi. Scegli quella più adatta a te, lasciaci una mail e la scarichi subito.",
            fuelingHub: {
                badge: "Nuovo · Live",
                overline: "Fueling Hub",
                title: "FUELING HUB — Executive Nutrition System",
                description: "Il tuo assistente metabolico h24 per gestire focus, sgarri e performance.",
                cta: "Accedi ora",
                url: "https://fit-fuel-calc-1.emergent.host",
            },
            chooseLabel: "Scegli la tua guida",
            selectedLabel: "Stai scaricando",
            items: [
                {
                    id: "transizione-ormonale-over-45",
                    file: "guida-1-transizione-ormonale-over-45.pdf",
                    badge: "Donna · Over 45",
                    title: "Il Codice della Rinascita",
                    subtitle: "Come resettare gli ormoni e ritrovare il tuo corpo a 45 anni",
                    description: "Per donne over 45 che vivono cambiamenti ormonali: capire gonfiore e stanchezza, ritrovare benessere e vitalità con strategie leggere e concrete.",
                },
                {
                    id: "ingegneria-movimento-donna",
                    file: "guida-2-ingegneria-movimento-donna.pdf",
                    badge: "Donna · No tempo",
                    title: "Meno Tempo, Più Forme",
                    subtitle: "Guida al movimento strategico per ritrovare tono e leggerezza senza stress",
                    description: "Per donne con agende piene: movimento mirato per ritrovare tono, leggerezza e riattivare il metabolismo, anche con poco tempo a disposizione.",
                },
                {
                    id: "protocollo-adhd-focus",
                    file: "guida-3-protocollo-adhd-focus.pdf",
                    badge: "ADHD · Focus",
                    title: "La Mente a Mille, il Corpo in Stasi",
                    subtitle: "Il metodo dopaminergico per allenarsi e stare bene quando odi la noia e le regole rigide",
                    description: "Per chi fatica con allenamenti rigidi: un metodo dopaminergico che rende il benessere stimolante e flessibile, a prova di attacco di noia.",
                },
                {
                    id: "thermal-resilience-caldo",
                    file: "guida-4-thermal-resilience.pdf",
                    badge: "Caldo · Performance",
                    title: "THERMAL RESILIENCE: Reset del Caldo",
                    subtitle: "Come dominare la tua biologia quando la temperatura sale",
                    description: "I 3 protocolli scientifici (Idratazione Elettrolitica, Core Reset, Recupero NSDR) per eliminare la nebbia mentale e restare lucidi sotto il caldo estremo.",
                },
            ],
            formOverline: "Scarica ora",
            formTitle: "Lascia i tuoi dati per ricevere la guida",
            firstNameLabel: "Nome",
            firstNamePlaceholder: "Mario",
            lastNameLabel: "Cognome",
            lastNamePlaceholder: "Rossi",
            emailLabel: "Email",
            emailPlaceholder: "mario.rossi@email.com",
            nationalityLabel: "Nazionalità (opzionale)",
            nationalityPlaceholder: "Italia",
            submitLabel: "Ricevi la guida",
            submitting: "Invio in corso…",
            errorValidation: "Compila Nome, Cognome ed Email valida.",
            errorGeneric: "Si è verificato un errore. Riprova tra qualche secondo.",
            privacyNote: "I tuoi dati saranno trattati esclusivamente per inviarti la guida richiesta e aggiornamenti sul Metodo Fit & Wellness. Nessuno spam, mai. Vedi la Privacy Policy.",
            successOverline: "Tutto fatto",
            successTitle: (name) => `Grazie ${name}! Controlla la tua email.`,
            successText: "Ti abbiamo appena inviato la guida in PDF via email. Il download è partito anche qui sul sito, come backup.",
            downloadAgain: "Scarica di nuovo",
        },
        quizCta: {
            overline: "Non sai quale scegliere?",
            headline: "Trova il tuo Protocollo in 60 secondi.",
            description: "Un mini-quiz da 6 domande per capire quale dei 7 protocolli Fit & Wellness è più adatto al tuo profilo, ai tuoi obiettivi e al tuo tempo.",
            cta: "Inizia il Quiz",
        },
        quiz: {
            backHome: "Torna alla home",
            overline: "Trova il tuo Protocollo",
            headline: "6 domande per il tuo protocollo su misura.",
            description: "Risposte sincere = risultato preciso. In meno di un minuto sapremo da quale dei 7 protocolli Fit & Wellness conviene partire.",
            resultOverline: "Il tuo protocollo consigliato",
            ctaWhatsapp: "Scrivi su WhatsApp",
            ctaCalendly: "Prenota Consulenza",
            ctaEmail: "Contatta via Email",
            seeProtocolDetail: "Approfondisci il protocollo",
            restart: "Rifai il quiz",
            questions: [
                {
                    overline: "Domanda 01 · Età",
                    question: "Qual è la tua fascia di età?",
                    backLabel: "Indietro",
                    options: ["Sotto i 35", "35 – 44", "45 – 54", "55 o più"],
                },
                {
                    overline: "Domanda 02 · Profilo",
                    question: "Come ti identifichi?",
                    backLabel: "Indietro",
                    options: ["Donna", "Uomo", "Preferisco non rispondere"],
                },
                {
                    overline: "Domanda 03 · Obiettivo",
                    question: "Qual è il tuo obiettivo principale oggi?",
                    backLabel: "Indietro",
                    options: [
                        "Forza e tono muscolare",
                        "Composizione corporea e dimagrimento",
                        "Longevità e salute generale",
                        "Postura, recupero infortuni",
                        "Energia stabile e lucidità mentale",
                        "Performance sportiva",
                    ],
                },
                {
                    overline: "Domanda 04 · Tempo",
                    question: "Quanto tempo puoi dedicare all'allenamento ogni settimana?",
                    backLabel: "Indietro",
                    options: [
                        "Meno di 2 ore",
                        "2 – 4 ore",
                        "4 – 6 ore",
                        "Più di 6 ore",
                    ],
                },
                {
                    overline: "Domanda 05 · Stress e sonno",
                    question: "Come valuti il tuo livello di stress e la qualità del sonno?",
                    backLabel: "Indietro",
                    options: [
                        "Basso stress, sonno buono",
                        "Stress medio, sonno discreto",
                        "Stress alto, sonno scarso",
                    ],
                },
                {
                    overline: "Domanda 06 · Modalità",
                    question: "Come preferisci essere seguito?",
                    backLabel: "Indietro",
                    options: [
                        "In presenza (Genova)",
                        "Online da remoto",
                        "Mi va bene entrambe",
                    ],
                },
            ],
        },
        footer: {
            tagline: "Personal Trainer · Performance Method",
            rights: "Tutti i diritti riservati.",
            method: "Metodo",
            contact: "Contatti",
            legal: "Legale",
            privacy: "Privacy",
            terms: "Termini",
        },
        privacy: {
            title: "Privacy Policy",
            updated: "Ultimo aggiornamento",
            back: "Torna alla home",
            sections: [
                { h: "1. Titolare del trattamento", p: "Il titolare del trattamento dei dati personali è Luca La Capria, contattabile all'indirizzo email fit.wellness2021@gmail.com e al numero +39 351 952 0592." },
                { h: "2. Dati raccolti", p: "Questo sito è una landing page statica. Non utilizziamo form di registrazione né raccogliamo dati personali direttamente dal sito. I dati raccolti riguardano esclusivamente le comunicazioni che invii volontariamente via WhatsApp o Email." },
                { h: "3. Finalità del trattamento", p: "I dati che ci comunichi (nome, contatti, obiettivi di allenamento, eventuali informazioni sanitarie) sono trattati esclusivamente per: (a) rispondere alle tue richieste; (b) erogare i servizi di personal training, preparazione atletica e consulenza alimentare; (c) adempiere a obblighi di legge." },
                { h: "4. Cookie e tecnologie analitiche", p: "Questo sito utilizza cookie tecnici essenziali per il funzionamento. Utilizziamo PostHog per analisi anonime aggregate. Non utilizziamo cookie di profilazione di terze parti per scopi pubblicitari." },
                { h: "5. Diritti dell'interessato", p: "Puoi esercitare in qualsiasi momento i diritti previsti dal GDPR (artt. 15-22): accesso, rettifica, cancellazione, limitazione, opposizione e portabilità. Scrivi a fit.wellness2021@gmail.com per qualsiasi richiesta." },
                { h: "6. Conservazione dei dati", p: "I dati saranno conservati per il tempo strettamente necessario alle finalità per cui sono raccolti e comunque non oltre il periodo richiesto dalla normativa fiscale e sanitaria." },
                { h: "7. Sicurezza", p: "Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati personali da accessi non autorizzati, perdita o divulgazione." },
            ],
        },
        terms: {
            title: "Termini e Condizioni",
            updated: "Ultimo aggiornamento",
            back: "Torna alla home",
            sections: [
                { h: "1. Servizi offerti", p: "Fit & Wellness offre servizi di personal training, preparazione atletica, consulenza alimentare e coaching online. Il presente sito è una landing page informativa: l'attivazione dei servizi avviene tramite contatto diretto (WhatsApp o Email) e accordo individuale." },
                { h: "2. Idoneità medica", p: "Prima di iniziare qualsiasi programma di allenamento è responsabilità del cliente verificare la propria idoneità medico-sportiva. Luca La Capria non sostituisce in alcun modo il parere di medici, fisioterapisti o specialisti." },
                { h: "3. Modalità di erogazione", p: "I servizi possono essere erogati in presenza (zona Genova e provincia) o online. Modalità, durata, frequenza e prezzi sono concordati individualmente al momento dell'attivazione." },
                { h: "4. Pagamenti e cancellazioni", p: "Le condizioni economiche e le politiche di cancellazione/rinvio delle sessioni sono definite nel singolo accordo con il cliente. In assenza di accordi specifici, sessioni cancellate con meno di 24 ore di preavviso si intendono dovute." },
                { h: "5. Proprietà intellettuale", p: "Tutti i contenuti del sito (testi, immagini, marchi, metodologia 'Fit & Wellness' e relativi protocolli) sono di proprietà di Luca La Capria. Ne è vietata la riproduzione senza autorizzazione scritta." },
                { h: "6. Limitazione di responsabilità", p: "L'utente si assume la responsabilità di eseguire correttamente gli esercizi proposti e di comunicare tempestivamente qualsiasi condizione fisica rilevante. Luca La Capria non risponde di danni derivanti da informazioni omesse o da esecuzioni scorrette degli esercizi al di fuori delle sessioni guidate." },
                { h: "7. Legge applicabile e foro competente", p: "I presenti termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente in via esclusiva il Foro di Genova." },
            ],
        },
        cookie: {
            overline: "Privacy · GDPR",
            title: "Rispetto della tua privacy",
            body: "Utilizziamo cookie tecnici essenziali per il funzionamento del sito e, solo previo tuo consenso, cookie analitici anonimi (PostHog) per migliorare l'esperienza. Nessun cookie di profilazione pubblicitaria.",
            accept: "Accetta tutti",
            reject: "Solo essenziali",
            details: "Dettagli & Privacy",
        },
        notFound: {
            overline: "Errore 404",
            title: "Pagina non trovata",
            body: "Il percorso che hai seguito non esiste o è stato spostato. Tornare alla home è sempre la mossa più allenata.",
            cta: "Torna alla Home",
            secondary: "Vedi i Protocolli",
        },
        thankYou: {
            overline: "Grazie",
            // Resource variant
            resourceTitle: (name) => `Grazie ${name || "ad ogni allenamento"} — la guida è in arrivo`,
            resourceBody: "Ti abbiamo appena spedito il PDF via email. Mentre lo leggi, fai il prossimo passo: prenota 15 minuti gratis con Luca e capiamo insieme come applicare il Metodo Fit & Wellness al tuo caso specifico.",
            // Quiz variant
            quizTitle: (name) => `${name ? name + ", il" : "Il"} tuo protocollo è pronto`,
            quizBody: "Il quiz ha individuato il protocollo che si adatta meglio ai tuoi obiettivi. Per costruirlo davvero su di te serve una valutazione 1-a-1: prenota 15 minuti gratis con Luca o scrivigli su WhatsApp.",
            // Generic
            primaryCta: "Prenota 15 min gratis con Luca",
            secondaryCta: "Scrivi su WhatsApp",
            tertiaryCta: "Vedi tutti i Protocolli",
            socialProof: "20+ clienti già nel Metodo · Risposta in 24h",
            checklistTitle: "Cosa succede ora",
            checklist: [
                "Controlla la casella email (anche Spam) — il PDF arriva entro 1 minuto",
                "Prenota la call di 15 minuti gratis dal pulsante qui sopra",
                "Riceverai una conferma Calendly con il link Zoom o l'indirizzo a Genova",
            ],
            backHome: "Torna alla home",
        },
        insights: {
            overline: "Insights · Scienza e Performance",
            headline: "Insights: Scienza e Performance",
            description: "La sezione editoriale del Metodo: ricerca tradotta in protocolli applicabili, lontano dalle mode. Aggiornata periodicamente con i temi che muovono davvero forza, longevità e lucidità.",
            signature: "By Luca La Capria · Fit & Wellness",
            readArticle: "Leggi l'articolo",
            readTimeLabel: "min di lettura",
        },
        article: {
            backToInsights: "Torna a Insights",
            relatedTitle: "Continua a leggere",
            signature: "Fit & Wellness · di Luca La Capria",
            ctaOverline: "Vuoi applicare questi principi al tuo caso?",
            ctaHeadline: "Scarica la guida e prenota la consulenza",
            ctaBody: "La guida PDF correlata approfondisce l'argomento con un protocollo operativo. La consulenza 1-a-1 con Luca lo cuce davvero su di te: 15 minuti gratis per capire da dove partire.",
            ctaDownloadGuide: "Scarica la guida correlata",
            ctaConsult: "Prenota Consulenza",
        },
    },
    en: {
        nav: {
            method: "The Method",
            protocols: "Protocols",
            bio: "Bio",
            testimonials: "Reviews",
            resources: "Resources",
            insights: "Insights",
            fuelingHub: "Fueling Hub",
            contact: "Contact",
            cta: "Book",
        },
        common: {
            showAllProtocols: "See all 7 protocols",
            showLess: "Show less",
            showAllArticles: "All articles",
        },
        hero: {
            overline: "Personal Trainer · Performance Method",
            headlineLine1: "Train.",
            headlineLine2: "Realign.",
            headlineLine3: "Regenerate.",
            sub: "Luca La Capria — Personal Trainer, Athletic Coach and Nutrition Consultant.",
            description: "A bespoke method engineered for those who live at high intensity. Strength, posture, performance and mental clarity: no generic formulas — only precision training.",
            ctaConsult: "Book a Strategy Call",
            ctaPrimary: "Message on WhatsApp",
            ctaSecondary: "Contact via Email",
            scroll: "Scroll",
            tickerWords: ["Strength", "Posture", "Performance", "Recovery", "Mindset", "Longevity"],
        },
        method: {
            overline: "The Method",
            headline: "The Fit & Wellness Method",
            description: "Seven protocols, one philosophy: design the body the way you design a performance system. Each path is a precision architecture built on your biology, your time and your goals.",
            protocolLabel: "Protocol",
            discoverMore: "Learn more",
        },
        protocols: [
            {
                id: "01",
                slug: "longevita-attiva-over-45",
                name: "Active Longevity Over 45",
                tagline: "Strength, mobility and vitality for the second half of life.",
                description: "A program rooted in longevity science: functional strength, cardiovascular capacity and joint mobility to stay bright, agile and powerful after 45.",
                detail: {
                    intro: "A program designed for those who want to keep on living — not just aging. We build together a strong, mobile, functional body able to face every decade with the same clarity and vitality.",
                    forWho: "Men and women aged 45+ who want to maintain (or rebuild) strength, energy and mobility. Suitable for those returning to training or already active.",
                    includes: [
                        "Initial functional assessment (mobility, strength, posture)",
                        "Progressive functional strength program",
                        "Joint mobility and injury prevention",
                        "Modulated cardio-metabolic work",
                        "General nutritional guidelines for longevity",
                    ],
                    format: "In person (Genoa) or online · 1-on-1",
                    duration: "Minimum 8 weeks · recommended 12-week cycles",
                },
            },
            {
                id: "02",
                slug: "reset-metabolico-neuro-wellness",
                name: "Metabolic Reset & Neuro-Wellness (ADHD)",
                tagline: "Mental and metabolic energy recalibrated.",
                description: "Integrated training, nutrition and neuro-wellness to recalibrate metabolism and support cognitive focus — also tailored for ADHD profiles.",
                detail: {
                    intro: "A protocol integrating movement, nutrition and nervous-system regulation techniques. Designed for those seeking stable energy, mental clarity and renewed metabolic mastery — including people with ADHD traits.",
                    forWho: "Professionals, creatives and people with ADHD or metabolic-syndrome traits who want to find energy stability, focus and healthy body composition.",
                    includes: [
                        "Eating-habit reset (timing, quality, supplementation)",
                        "Training adapted to energy and focus windows",
                        "Breathwork and stress-management techniques",
                        "Sustainable daily routine strategies",
                        "Weekly energy and mood monitoring",
                    ],
                    format: "In person (Genoa) or online · 1-on-1",
                    duration: "8 to 16-week cycles",
                },
            },
            {
                id: "03",
                slug: "postura-riatletizzazione",
                name: "Posture & Re-athletization",
                tagline: "Realign the body, reawaken the athlete.",
                description: "Postural assessment, kinetic chain correction and a structured return to performance after injury, sedentariness or chronic stress.",
                detail: {
                    intro: "When the body misaligns, every movement becomes a hidden effort. This protocol rebuilds the foundation — posture, mobility, kinetic chains — so your body works with you, not against you.",
                    forWho: "People with postural issues, chronic back or neck pain, those returning to training after injury, sedentary people starting again the right way.",
                    includes: [
                        "Complete postural and functional assessment",
                        "Targeted mobility and activation work",
                        "Kinetic-chain correction",
                        "Progressive re-athletization",
                        "Daily-movement education",
                    ],
                    format: "In person (Genoa) · 1-on-1 sessions",
                    duration: "Minimum 6 weeks · often 12-16 weeks",
                },
            },
            {
                id: "04",
                slug: "express-performance-20",
                name: "Express Performance 20'",
                tagline: "Maximum result, minimum time.",
                description: "High-density 20-minute sessions, engineered for closed agendas that still demand strength, sharpness and tone.",
                detail: {
                    intro: "Twenty minutes, no more — but built like a professional session. HIIT, functional strength and neuro-muscular work in a concentrated format for those with packed schedules and high standards.",
                    forWho: "Professionals, managers and high performers with limited time who want concrete results without sacrificing quality.",
                    includes: [
                        "20-minute high-density sessions",
                        "HIIT, functional strength and mobility",
                        "Program adapted to weekly schedule",
                        "Possibility of sessions in studio or office",
                        "Recovery and recharge guidance",
                    ],
                    format: "In person (Genoa) or online · 1-on-1 or pair",
                    duration: "Ongoing format · visible results in 4-8 weeks",
                },
            },
            {
                id: "05",
                slug: "mind-recovery",
                name: "Mind & Recovery",
                tagline: "Active recovery, sleep, nervous system.",
                description: "Breathwork, gentle mobility and stress-management protocols to rebuild the nervous system and optimize deep recovery.",
                detail: {
                    intro: "Training hard is not enough: real performance comes from recovery. This protocol works on the parasympathetic nervous system — breath, gentle mobility, sleep regulation — to bring the body back into balance.",
                    forWho: "People under chronic stress, those struggling with insomnia or poor recovery, amateur athletes who want to optimize their post-training.",
                    includes: [
                        "Breathing techniques (box, physiological, Wim Hof)",
                        "Gentle mobility and myofascial release",
                        "Structured pre-sleep routine",
                        "Stress management and meditative techniques",
                        "HRV and recovery-quality monitoring",
                    ],
                    format: "In person (Genoa) or online · 1-on-1",
                    duration: "4 to 12-week cycles",
                },
            },
            {
                id: "06",
                slug: "equilibrio-femminile",
                name: "Feminine Balance",
                tagline: "Cyclical training, hormones and strength.",
                description: "A path dedicated to the feminine universe: hormonal cycles, strength, body composition and wellbeing — designed with science and sensitivity.",
                detail: {
                    intro: "The female body is not a smaller male body. This protocol trains in sync with hormonal cycles, modulating intensity, volume and nutrition to optimize strength, energy and wellbeing phase by phase.",
                    forWho: "Women in every life phase — pre-menstrual, fertile, perimenopause, menopause — who want to train respecting their biology.",
                    includes: [
                        "Hormone-aware cyclical training",
                        "Strength, hypertrophy and modulated cardio",
                        "Nutrition by cycle phase",
                        "Retention, energy and mood management",
                        "Pelvic-floor and core work",
                    ],
                    format: "In person (Genoa) or online · 1-on-1 or small groups",
                    duration: "Ongoing path · quarterly reviews",
                },
            },
            {
                id: "07",
                slug: "metodo-online",
                name: "Online Method",
                tagline: "The method, wherever you are.",
                description: "The Fit & Wellness system in digital form: personalized programs, video-coaching and constant monitoring for those always on the move.",
                detail: {
                    intro: "For those who travel, live abroad or cannot reach the studio — the Fit & Wellness Method fully online, keeping the same level of personalization and care as in-person work.",
                    forWho: "Traveling professionals, Italians abroad, amateur athletes, those without access to a trusted local trainer.",
                    includes: [
                        "100% personalized program via app",
                        "Video correction of exercise execution",
                        "Weekly or bi-weekly Zoom/WhatsApp calls",
                        "Direct chat for questions and adjustments",
                        "Nutrition and recovery guidance",
                    ],
                    format: "100% online · Zoom + app + WhatsApp",
                    duration: "4, 8 or 12-week cycles",
                },
            },
        ],
        protocolPage: {
            backToProtocols: "Back to protocols",
            backHome: "Back to home",
            forWho: "Who it's for",
            includes: "What's included",
            format: "Format",
            duration: "Duration",
            ctaTitle: "Want to start this protocol?",
            ctaText: "Write to me for a free consultation — we'll build the program best suited to you, together.",
            ctaWhatsapp: "Message on WhatsApp",
            ctaEmail: "Contact via Email",
            protocolNumber: "Protocol",
            notFound: "Protocol not found",
        },
        bio: {
            overline: "About",
            headline: "Luca La Capria",
            role: "Personal Trainer · Athletic Coach · Nutrition Consultant",
            paragraphs: [
                "I am Luca La Capria. I've practiced sport since childhood — competitive football, then competitive running on 10–12 km — and for over a decade I've designed training journeys for everyday people of all ages, amateur athletes and professionals.",
                "The Fit & Wellness method is born at the intersection of three disciplines: training science (strength, HIIT, running, posture), functional nutrition and neuro-wellness. My mission is to practically support you in rebuilding mind and body, for your wellbeing and your longevity.",
                "I work 1-on-1, in small groups, and online — both in person and remotely. I work with people with postural issues, those who want to regain shape and energy, and athletes seeking concrete progress. No generic formulas: only precision training built for the long run.",
            ],
            credentials: [
                { label: "Years of experience", value: "12+" },
                { label: "Clients trained", value: "200+" },
                { label: "Protocols", value: "7" },
                { label: "Sessions / year", value: "1.4K" },
            ],
            certifications: [
                "Personal Trainer — NonSoloFitness",
                "Athletic & Sports Coach",
                "HIIT Instructor & Female Training",
                "Sports & Clinical Nutrition Educator",
                "Postural Gymnastics Instructor",
                "Mental Trainer for Fitness",
            ],
        },
        testimonials: {
            overline: "Reviews",
            headline: "The voice of those who chose the Method",
            description: "Real reviews from ProntoPro and Fit & Wellness Method clients.",
            verified: "Verified review",
            items: [
                { quote: "Amazing coach! Workouts respect my needs, always available, encouraging and realistic. Highly recommended!", author: "Anna P.", role: "Client · 02/2026", source: "ProntoPro" },
                { quote: "A capital-P Professional. Super available and always ready to understand every situation. Complete technical background. Try to believe.", author: "Mattia B.", role: "Client · 11/2025", source: "ProntoPro" },
                { quote: "Training program tailored to complex time needs (shift work). Punctual support, you know you can count on him and he's understanding about the time available. Recommended.", author: "Davide B.", role: "Client · 08/2025", source: "ProntoPro" },
                { quote: "The Express Performance 20' protocol fit perfectly into my days. Measurable results, impeccable approach.", author: "Alessandra R.", role: "Manager", source: "Direct client" },
                { quote: "I got back in shape after a chronic injury thanks to the work on posture and re-athletization. Serious, professional and tailored method.", author: "Marco V.", role: "Amateur athlete", source: "Direct client" },
                { quote: "Truly unique mind-body approach. Breathwork, training and nutrition integrated — finally stable energy all day long.", author: "Chiara M.", role: "Professional", source: "Direct client" },
            ],
        },
        cta: {
            overline: "Begin",
            headline: "Ready to start your Method?",
            description: "A private consultation to design the Fit & Wellness protocol most suited to your profile, your time and your goals.",
            calendly: "Book a Strategy Call",
            whatsapp: "Message on WhatsApp",
            email: "Send an Email",
            phoneLabel: "Phone",
            emailLabel: "Email",
        },
        resources: {
            overline: "Resources Area",
            headline: "Free resources to start strong.",
            description: "Strategic guides from the Fit & Wellness Method, on precise topics. Pick the one that suits you, leave your email, and download instantly.",
            fuelingHub: {
                badge: "New · Live",
                overline: "Fueling Hub",
                title: "FUELING HUB — Executive Nutrition System",
                description: "Your 24/7 metabolic assistant to manage focus, cheat meals and performance.",
                cta: "Access now",
                url: "https://fit-fuel-calc-1.emergent.host",
            },
            chooseLabel: "Choose your guide",
            selectedLabel: "You're downloading",
            items: [
                {
                    id: "transizione-ormonale-over-45",
                    file: "guida-1-transizione-ormonale-over-45.pdf",
                    badge: "Women · Over 45",
                    title: "Il Codice della Rinascita",
                    subtitle: "How to reset hormones and rediscover your body at 45",
                    description: "For women over 45 facing hormonal change: understand bloating and fatigue, regain energy and vitality with light, concrete strategies.",
                },
                {
                    id: "ingegneria-movimento-donna",
                    file: "guida-2-ingegneria-movimento-donna.pdf",
                    badge: "Women · No time",
                    title: "Meno Tempo, Più Forme",
                    subtitle: "Strategic-movement guide to regain tone and lightness, stress-free",
                    description: "For women with busy schedules: targeted movement to regain tone, lightness and reactivate metabolism — even with very little time available.",
                },
                {
                    id: "protocollo-adhd-focus",
                    file: "guida-3-protocollo-adhd-focus.pdf",
                    badge: "ADHD · Focus",
                    title: "La Mente a Mille, il Corpo in Stasi",
                    subtitle: "The dopaminergic method to train and feel good when you hate boredom and rigid rules",
                    description: "For those who struggle with rigid workouts: a dopaminergic method that makes wellbeing stimulating and flexible, immune to boredom attacks.",
                },
                {
                    id: "thermal-resilience-caldo",
                    file: "guida-4-thermal-resilience.pdf",
                    badge: "Heat · Performance",
                    title: "THERMAL RESILIENCE: Heat Reset",
                    subtitle: "How to dominate your biology when the temperature rises",
                    description: "The 3 scientific protocols (Electrolyte Hydration, Core Reset, NSDR Recovery) to clear mental fog and stay sharp under extreme heat.",
                },
            ],
            formOverline: "Download now",
            formTitle: "Enter your details to receive the guide",
            firstNameLabel: "First name",
            firstNamePlaceholder: "John",
            lastNameLabel: "Last name",
            lastNamePlaceholder: "Smith",
            emailLabel: "Email",
            emailPlaceholder: "john.smith@email.com",
            nationalityLabel: "Nationality (optional)",
            nationalityPlaceholder: "United Kingdom",
            submitLabel: "Receive the guide",
            submitting: "Sending…",
            errorValidation: "Please provide First Name, Last Name and a valid Email.",
            errorGeneric: "Something went wrong. Please try again in a moment.",
            privacyNote: "Your details will be used only to send you the requested guide and updates about the Fit & Wellness Method. No spam, ever. See the Privacy Policy.",
            successOverline: "All set",
            successTitle: (name) => `Thank you ${name}! Check your inbox.`,
            successText: "We just sent the PDF guide to your email. The download has also started here on the site as a backup.",
            downloadAgain: "Download again",
        },
        quizCta: {
            overline: "Not sure which one to pick?",
            headline: "Find your Protocol in 60 seconds.",
            description: "A 6-question mini-quiz to discover which of the 7 Fit & Wellness protocols best fits your profile, goals and time.",
            cta: "Start the Quiz",
        },
        quiz: {
            backHome: "Back to home",
            overline: "Find your Protocol",
            headline: "6 questions for your tailored protocol.",
            description: "Honest answers = precise result. In under a minute we'll know which of the 7 Fit & Wellness protocols suits you best.",
            resultOverline: "Your recommended protocol",
            ctaWhatsapp: "Message on WhatsApp",
            ctaCalendly: "Book Consultation",
            ctaEmail: "Contact via Email",
            seeProtocolDetail: "Explore the protocol",
            restart: "Retake the quiz",
            questions: [
                {
                    overline: "Question 01 · Age",
                    question: "What's your age range?",
                    backLabel: "Back",
                    options: ["Under 35", "35 – 44", "45 – 54", "55 or more"],
                },
                {
                    overline: "Question 02 · Profile",
                    question: "How do you identify?",
                    backLabel: "Back",
                    options: ["Woman", "Man", "Prefer not to say"],
                },
                {
                    overline: "Question 03 · Goal",
                    question: "What is your main goal today?",
                    backLabel: "Back",
                    options: [
                        "Strength and muscle tone",
                        "Body composition and weight loss",
                        "Longevity and overall health",
                        "Posture, injury recovery",
                        "Stable energy and mental clarity",
                        "Sports performance",
                    ],
                },
                {
                    overline: "Question 04 · Time",
                    question: "How much time can you dedicate to training each week?",
                    backLabel: "Back",
                    options: [
                        "Less than 2 hours",
                        "2 – 4 hours",
                        "4 – 6 hours",
                        "More than 6 hours",
                    ],
                },
                {
                    overline: "Question 05 · Stress and sleep",
                    question: "How would you rate your stress level and sleep quality?",
                    backLabel: "Back",
                    options: [
                        "Low stress, good sleep",
                        "Medium stress, decent sleep",
                        "High stress, poor sleep",
                    ],
                },
                {
                    overline: "Question 06 · Format",
                    question: "How do you prefer to be coached?",
                    backLabel: "Back",
                    options: [
                        "In person (Genoa)",
                        "Fully online",
                        "Either works for me",
                    ],
                },
            ],
        },
        footer: {
            tagline: "Personal Trainer · Performance Method",
            rights: "All rights reserved.",
            method: "Method",
            contact: "Contact",
            legal: "Legal",
            privacy: "Privacy",
            terms: "Terms",
        },
        privacy: {
            title: "Privacy Policy",
            updated: "Last updated",
            back: "Back to home",
            sections: [
                { h: "1. Data controller", p: "The data controller is Luca La Capria, reachable at fit.wellness2021@gmail.com and +39 351 952 0592." },
                { h: "2. Data collected", p: "This site is a static landing page. We do not use registration forms and do not collect personal data directly from the site. Data collected concerns only the communications you voluntarily send via WhatsApp or Email." },
                { h: "3. Purpose of processing", p: "Data you send us (name, contacts, training goals, any health information) is processed only to: (a) reply to your requests; (b) deliver personal training, athletic preparation and nutrition consulting services; (c) comply with legal obligations." },
                { h: "4. Cookies and analytics", p: "This site uses essential technical cookies. We use PostHog for anonymous aggregate analytics. We do not use third-party profiling cookies for advertising." },
                { h: "5. Your rights", p: "You may exercise at any time the rights provided by GDPR (art. 15-22): access, rectification, erasure, limitation, opposition and portability. Write to fit.wellness2021@gmail.com for any request." },
                { h: "6. Data retention", p: "Data will be retained only for the time strictly necessary for the purposes for which it is collected and in any case not beyond the period required by fiscal and health regulations." },
                { h: "7. Security", p: "We adopt appropriate technical and organizational measures to protect your personal data from unauthorized access, loss or disclosure." },
            ],
        },
        terms: {
            title: "Terms and Conditions",
            updated: "Last updated",
            back: "Back to home",
            sections: [
                { h: "1. Services offered", p: "Fit & Wellness offers personal training, athletic coaching, nutrition consulting and online coaching services. This site is an informational landing page: services are activated via direct contact (WhatsApp or Email) and individual agreement." },
                { h: "2. Medical eligibility", p: "Before starting any training program, it is the client's responsibility to verify their own medical-sports eligibility. Luca La Capria does not in any way replace the opinion of doctors, physiotherapists or specialists." },
                { h: "3. Delivery", p: "Services may be delivered in person (Genoa area) or online. Modalities, duration, frequency and prices are agreed individually at activation." },
                { h: "4. Payments and cancellations", p: "Economic terms and cancellation/rescheduling policies are defined in the individual client agreement. In the absence of specific agreements, sessions cancelled with less than 24 hours' notice are considered due." },
                { h: "5. Intellectual property", p: "All site content (texts, images, trademarks, the 'Fit & Wellness' methodology and related protocols) is owned by Luca La Capria. Reproduction without written authorization is prohibited." },
                { h: "6. Limitation of liability", p: "The user is responsible for correctly executing the exercises proposed and for promptly communicating any relevant physical condition. Luca La Capria is not liable for damages arising from omitted information or incorrect execution of exercises outside guided sessions." },
                { h: "7. Applicable law and jurisdiction", p: "These terms are governed by Italian law. For any dispute, the Court of Genoa shall have exclusive jurisdiction." },
            ],
        },
        cookie: {
            overline: "Privacy · GDPR",
            title: "Your privacy matters",
            body: "We use essential technical cookies to run the site and, only with your consent, anonymous analytics cookies (PostHog) to improve the experience. No advertising profiling cookies.",
            accept: "Accept all",
            reject: "Essentials only",
            details: "Details & Privacy",
        },
        notFound: {
            overline: "Error 404",
            title: "Page not found",
            body: "The path you followed doesn't exist or has been moved. Heading back to home is always the best-trained move.",
            cta: "Back to Home",
            secondary: "See the Protocols",
        },
        thankYou: {
            overline: "Thank you",
            resourceTitle: (name) => `Thanks ${name || "for training with us"} — your guide is on its way`,
            resourceBody: "We just emailed the PDF. While you read it, take the next step: book 15 free minutes with Luca and let's design how the Fit & Wellness Method applies to your specific case.",
            quizTitle: (name) => `${name ? name + ", your" : "Your"} protocol is ready`,
            quizBody: "The quiz spotted the protocol best suited to your goals. To truly build it around you we need a 1-on-1 assessment: book 15 free minutes with Luca or text him on WhatsApp.",
            primaryCta: "Book 15 free min with Luca",
            secondaryCta: "Message on WhatsApp",
            tertiaryCta: "See all Protocols",
            socialProof: "20+ clients already in the Method · Reply within 24h",
            checklistTitle: "What happens next",
            checklist: [
                "Check your inbox (including Spam) — the PDF arrives within a minute",
                "Book the free 15-minute call from the button above",
                "You'll get a Calendly confirmation with the Zoom link or the Genoa address",
            ],
            backHome: "Back to home",
        },
        insights: {
            overline: "Insights · Science and Performance",
            headline: "Insights: Science and Performance",
            description: "The editorial section of the Method: research translated into applicable protocols, far from fads. Updated regularly with the topics that actually move strength, longevity and mental clarity.",
            signature: "By Luca La Capria · Fit & Wellness",
            readArticle: "Read the article",
            readTimeLabel: "min read",
        },
        article: {
            backToInsights: "Back to Insights",
            relatedTitle: "Keep reading",
            signature: "Fit & Wellness · by Luca La Capria",
            ctaOverline: "Want to apply these principles to your case?",
            ctaHeadline: "Download the guide and book the consult",
            ctaBody: "The related PDF guide goes deeper into the topic with an operational protocol. The 1-on-1 consultation with Luca tailors it to you: 15 free minutes to understand where to start.",
            ctaDownloadGuide: "Download the related guide",
            ctaConsult: "Book a Consult",
        },
    },
};

export const CONTACT = {
    phone: "3519520592",
    phoneInternational: "393519520592",
    phoneDisplay: "+39 351 952 0592",
    email: "fit.wellness2021@gmail.com",
    whatsappUrl: "https://wa.me/393519520592",
    emailUrl: "mailto:fit.wellness2021@gmail.com",
    calendlyUrl: "https://calendly.com/fit-wellness2021/30min",
};

export const BRAND = {
    logoLight: "/assets/logo-light.png",
    logoLightWebp: "/assets/logo-light.webp",
    logoDark: "/assets/logo-dark.png",
    logoDarkWebp: "/assets/logo-dark.webp",
    avatar: "/assets/avatar.jpg",
    avatarWebp: "/assets/avatar.webp",
    lucaPhoto: "/assets/luca.jpg?v=2",
    lucaPhotoWebp: "/assets/luca.webp?v=2",
};
